import { useCustomToast } from '@elkaso-app/web-design';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import http from 'apis/config/vendor-http-service';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetKasoWarehousesApi } from './use-get-kaso-warehouses-api';

const endpoint = 'map-warehouse';
export const unMapBranchEndpointIdentifier = endpoint;

type TData = Record<string, any>;
type TError = AxiosError;

export type TVariables = {
  branchId: number;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables>;

export function useUnmapWarehouseApi(options?: Options): ReturnType {
  const { refetch: refetchKasoWarehouses } = useGetKasoWarehousesApi({ enabled: false });
  const toast = useCustomToast();

  const mutationFn = async ({ branchId }: TVariables) => {
    try {
      const { data } = await http.delete(endpoint + `/${branchId}`);

      // re-fetch warehouses list
      refetchKasoWarehouses();

      toast({
        description: 'Warehouse have been unmapped successfully',
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: 'Something went wrong! Try again later',
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: endpoint, ...options });
}
